/** Reads image dimensions from a local File without keeping the object URL alive.
 *  Returns `null` when the browser cannot decode the format (e.g. HEIC on Chrome). */
export function getLocalImageDimensions(file: File): Promise<{ height: number; width: number } | null> {
  return new Promise((resolve) => {
    let objectUrl: string;
    try {
      objectUrl = URL.createObjectURL(file);
    } catch {
      resolve(null);
      return;
    }

    const img = new window.Image();

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
      img.onload = null;
      img.onerror = null;
      img.src = '';
    };

    img.onload = () => {
      resolve({ height: img.naturalHeight, width: img.naturalWidth });
      cleanup();
    };

    img.onerror = () => {
      cleanup();
      resolve(null);
    };

    img.src = objectUrl;
  });
}
